import { render, staticRenderFns } from "./banDialog.vue?vue&type=template&id=0c3b3b18&scoped=true&"
import script from "./banDialog.vue?vue&type=script&lang=js&"
export * from "./banDialog.vue?vue&type=script&lang=js&"
import style0 from "./banDialog.vue?vue&type=style&index=0&id=0c3b3b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b3b18",
  null
  
)

export default component.exports